import React from "react";


// Placeholder for fallback on mismanaged route navigation
// Ignored due to limited scope of site as a basic protfolio
// No real chance of accidentally navigating to a bad URL
const Fallback = () => {
    return(
        <></>
    )
}

export default Fallback;